export enum ReportJobStatus {
  PENDING = "PENDING",
  GENERATING = "GENERATING",
  PENDING_REVIEW = "PENDING REVIEW",
  AWAITING_INPUT = "AWAITING INPUT",
  // Parked because some (not all) videos failed transcription: the user must
  // decide whether to generate without them or cancel. Distinct from the
  // general HITL AWAITING_INPUT so every surface can branch synchronously.
  AWAITING_TRANSCRIPT_DECISION = "AWAITING TRANSCRIPT DECISION",
  FAILED = "FAILED",
  STARTED = "STARTED",
  EXTRACTING = "EXTRACTING",
}
